export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'dashboard',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Vehicle Import',
      //   to: '/vehicle-import',
      //   icon: 'download',
      //   _attrs: {
      //     class: 'pl-1'
      //   },
      //   exact: false,
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Incoming Inventory',
      //   to: '/incoming-inventory',
      //   icon: 'incoming-inventory',
      //   _attrs: {
      //     class: 'pl-1'
      //   },
      //   exact: false,
      // },
      
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Listing Over $26k',
      //   to: '/listing-over-26',
      //   icon: 'listing-over',
      //   _attrs: {
      //     class: 'pl-1'
      //   },
      //   exact: false,
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Sold/NA Listings',
      //   to: '/marketplace-sold',
      //   icon: 'sold',
      //   _attrs: {
      //     class: 'pl-1'
      //   },
      //   exact: false,
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Marketplace Reconciliation',
      //   to: '/marketplace-reconciliation',
      //   icon: 'reconciliation',
      //   _attrs: {
      //     class: 'pl-1'
      //   },
      //   exact: false,
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Draft Vehicle Manager',
        to: '/draft-vehicle-manager',
        icon: 'auction-managment',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Vehicle Manager',
        to: '/vehicle-manager',
        icon: 'auction-managment',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      
      {
        _name: 'CSidebarNavItem',
        name: 'Marketplace Listing',
        to: '/marketplace-listing',
        icon: 'marketplace-listing',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Marketplace Vehicle Sold',
        to: '/marketplace-vehicle-sold',
        icon: 'auction-managment',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Auction management',
        to: '/auction-management',
        icon: 'auction-managment',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Tesla Vehicle Listing',
        to: '/tesla-listing',
        icon: 'auction-managment',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'User manager',
        to: '/user-manager',
        icon: 'user',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Consumer Leads',
        to: '/consumer-leads',
        icon: 'user',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Dealer Leads',
        to: '/dealers',
        icon: 'user',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Payments',
        to: '/payments',
        icon: 'sales',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Support',
        to: '/support',
        icon: 'support',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Sales revenue',
        to: '/sales-revenue',
        icon: 'sales',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Managers',
        to: '/managers',
        icon: 'managers',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Tips & Tricks',
        to: '/tips-&-tricks',
        icon: 'managers',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'SEO',
        to: '/seo',
        icon: 'managers',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'FAQ Articles',
        to: '/faq-articles',
        icon: 'managers',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Auction Banner',
        to: '/auction-banner',
        icon: 'managers',
        _attrs: {
          class: 'pl-1'
        },
        exact: false,
      }
    ]
  }
]
